import React, { useState } from 'react';
import { IconButton, Stack, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { motion } from 'framer-motion';
import logo1 from "../../../assets/logosection/logo1.png"
import logo2 from "../../../assets/logosection/logo2.png"
import logo3 from "../../../assets/logosection/logo3.png"
import logo4 from "../../../assets/logosection/logo4.jpg"
import logo5 from "../../../assets/logosection/logo5.jpg"
import logo6 from "../../../assets/logosection/logo6.jpg"
import logo7 from "../../../assets/logosection/logo7.png"
import logo8 from "../../../assets/logosection/logo8.png"
import logo9 from "../../../assets/logosection/logo9.jpg"
import logo10 from "../../../assets/logosection/logo10.jpg"
import logo11 from "../../../assets/logosection/logo11.png"

const logos = [
  logo1, logo2, logo3, logo4, logo5, logo6,
  logo7, logo8, logo9, logo10, logo11
];

const FoundationsCarousel = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm')); // Mobile breakpoint

  // Adjust visibleCount, logoWidth, gap based on screen size
  const visibleCount = isSm ? 3 : 8;
  const logoWidth = isSm ? 80 : 96;
  const gap = isSm ? 16 : 32;

  const [startIndex, setStartIndex] = useState(0);
  const totalItems = logos.length;
  const maxIndex = totalItems - visibleCount;

  const handleNext = () => {
    setStartIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setStartIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <Stack spacing={3} alignItems="center" width="100%" px={isSm ? 0 : 0}>
      <Typography
        variant={isSm ? "h5" : "h3"}
        component="h2"
        fontWeight="bold"
        textAlign="center"
        sx={{fontFamily: "Montserrat, sans-serif",}}
      >
        Foundations
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1} width="100%" justifyContent="center">
        <IconButton
          onClick={handlePrev}
          color="success"
          aria-label="Previous logos"
          size={isSm ? "small" : "medium"}
        >
          <ChevronLeft fontSize={isSm ? "medium" : "large"} />
        </IconButton>

        <Box
          sx={{
            width: visibleCount * (logoWidth + gap) - gap,
            overflow: 'hidden',
          }}
        >
          <motion.div
            style={{ display: 'flex', gap: gap }}
            animate={{ x: -startIndex * (logoWidth + gap) }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            {logos.map((logo, index) => (
              <Box
                key={index}
                component="img"
                src={logo}
                alt={`Foundation ${index + 1}`}
                sx={{
                  width: logoWidth,
                  height: 'auto',
                  objectFit: 'contain',
                  userSelect: 'none',
                }}
                draggable={false}
              />
            ))}
          </motion.div>
        </Box>

        <IconButton
          onClick={handleNext}
          color="success"
          aria-label="Next logos"
          size={isSm ? "small" : "medium"}
        >
          <ChevronRight fontSize={isSm ? "medium" : "large"} />
        </IconButton>
      </Stack>

      <Stack direction="row" spacing={1}>
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: isSm ? 8 : 10,
              height: isSm ? 8 : 10,
              borderRadius: '50%',
              bgcolor: i === startIndex ? 'success.main' : 'teal.900',
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default FoundationsCarousel;
